<template>
    <v-container fluid ma-3 pa-3>
        <v-layout row wrap justify-center>
            <v-flex>
                <span class="style_title">Challenge Registration</span>
                <br>
                <br>
                <div>
                    <span class="style_description" style="white-space: pre-line">Discovery supports thematic challenges, focused on actual business needs, which can be solved through innovative technologies and processes.
Through these challenges, startups have a unique chance to show how their value proposition can serve business needs in a real and competitive environment.
On the Discovery platform, startups can view currently open challenges. These are hot topics on which NTT DATA or other customers are interested and for which they are looking for startups.

By clicking on the "Discover challenges" button on the homepage or on the "Startup-related services" -> "Challenges" toolbar, startups can view a list of currently published and valid challenges.
For each challenge you can see the main information on the dedicated card:
                        <ul>
                            <li>Title</li>
                            <li>First lines of the description</li>
                            <li>List of tags identifying the topic</li>
                        </ul>
And by clicking on the small arrow in the bottom right corner of the card:
                        <ul>
                            <li>Reward</li>
                            <li>Expiry date / Deadline</li>
                        </ul>
                        <br>
                        <v-img
                                max-width="400"
                                :src="require('@/assets/img/help/cardChallenge.png')"
                        >
                </v-img>
By clicking on the button "Explore" at the bottom left of the card you can read in detail what the challenge is about with a more detailed description.
If you want to register to the challenge, just click on the pink button "Register here".

The first step is to read and confirm the <strong>Terms & Conditions</strong>.
The second step is to insert in the space provided your identification token (received by email during the Discovery registration phase) and upload a PDF file (max 5 MB) that best describes the proposed solution.
The submission is protected for security reasons by a <strong>Google Captcha</strong>, which you must pass by checking the "I am not a robot" box.
Only if you have followed these steps correctly will you be able to submit your solution to the challenge, by clicking on "Participate".

If the submission is successful, a message will be displayed confirming receipt of the proposal.
In case of problems, a red error window will be displayed. We recommend that you contact the Discovery administrators in this case.

</span>
                </div>
                <br>


            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    export default {
        name: "ChallengeRegistrationHelp",
        components: {},
        data() {
            return {

            }
        },

        methods: {

        }
    }
</script>

<style scoped>
    .style_description{
        font-size: 18px;
    }

    .style_title{
        font-size: 34px;
        font-weight: bold;
    }

</style>